import { Injectable, InjectionToken } from '@angular/core';
import { CartModification, Converter, ConverterService, Occ, PRODUCT_NORMALIZER } from '@spartacus/core';

export const CART_MODIFICATION_NORMALIZER = new InjectionToken<Converter<any, CartModification>>(
  'CartModificationNormalizer',
);

@Injectable({ providedIn: 'root' })
export class OccCartModificationNormalizer implements Converter<Occ.CartModification, CartModification> {
  constructor(private converter: ConverterService) {}

  convert(source: Occ.CartModification, target?: CartModification): CartModification {
    if (target === undefined) {
      target = { ...(source as any) };
    }

    if (source && source.entry) {
      target.entry = {
        ...source.entry,
        product: this.converter.convert(source.entry.product, PRODUCT_NORMALIZER),
      };
    }

    return target;
  }
}
